import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import _ from 'lodash';
import { RootState } from 'store';

import { searchCities } from 'actions/cities';
import CitiesSearch from 'components/CitiesSearch';
import { City } from 'models/city';

interface Props {
  show: boolean;
  placeHolder: string;
  onClose: () => void;
  onChange: (city?: City) => void;
}

const CitiesSearchContainer = (props: Props) => {
  const dispatch = useDispatch();
  const citiesState = useSelector((state: RootState) => state.cities);

  const handleSearchChange = _.debounce((value: string) => {
    if (value && value.length > 2) {
      dispatch(searchCities(value));
    }
  }, 250);

  return <CitiesSearch {...props} {...citiesState} minLengthForSearch={2} onSearchChange={handleSearchChange} />;
};

export default CitiesSearchContainer;
